import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import HeatPumpDetail from '../../components/hot_water_system/HeatPumpDetail';
import { defaultRejectHandler } from '../../utils/utility';
import { editHeatPump } from '../../redux/heat_pump/heat_pump_actions';

class HeatPumpEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.heatPumpDetail = undefined;
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newHeatPump = this.heatPumpDetail.getWrappedInstance().getWrappedInstance().getHeatPumpData();
    this.props.editHeatPump({ ...newHeatPump, id: this.props.heatPump.id });
  }

  render() {
    const { isEditing, errorMessage, heatPump, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('edit heat pump')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <HeatPumpDetail
            heatPump={heatPump}
            ref={ref => (this.heatPumpDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="hot-water-heat-pump-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const heatPumpState = state.hotWaterSystem.heatPump;
  return {
    errorMessage: heatPumpState.errorMessage,
    isEditing: heatPumpState.isEditing,
  };
};

const mapDispatchToProps = dispatch => ({
  editHeatPump: heatPump =>
    defaultRejectHandler(
      dispatch(
        editHeatPump(
          heatPump.id,
          heatPump.name,
          heatPump.type_id,
          heatPump.COP,
          heatPump.description,
          heatPump.image,
          heatPump.cfp_value,
          heatPump.cfp_unit,
        ),
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(HeatPumpEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/heat_pump/HeatPumpEditModal.js